import styled from "styled-components";

export const Wrapper = styled.div`
  #player-root {
    height: 100vh;
  }
`;
